import type { PortalLocale } from "./portalShell";

/**
 * Map the portal locale to a BCP 47 tag for `Intl`.
 *
 * The portal stores bare language codes (`en` / `hi`), but every learner is in
 * India, so pin the region — otherwise `en` formats dates as `Aug 4` US-style
 * and weekday/number conventions drift from what the rest of the app shows.
 */
export function intlLocale(locale: PortalLocale): string {
  return locale === "hi" ? "hi-IN" : "en-IN";
}
